const relatedNews = () => {
  (function ($) {
    const $slickRelatedNews = $(".c-related-news .js-slick");

    $slickRelatedNews.slick({
      infinite: false,
      mobileFirst: true,
      centerMode: true,
      centerPadding: "40px",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
      ],
    });
  })(jQuery);
};

export default relatedNews;
